import { useEffect, useState } from "react";

/**
 * useInView - React hook for IntersectionObserver in-view detection
 * @param ref - React ref to the element to observe
 * @param options - Optional: { margin?: string }
 * @returns boolean - true if in view
 */
export function useInView(
  ref: { current: HTMLElement | null },
  options?: { margin?: string }
) {
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
        }
      },
      { rootMargin: options?.margin || "0px" }
    );
    observer.observe(node);
    return () => {
      observer.disconnect();
    };
  }, [ref, options?.margin]);
  return inView;
}
